<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">เติมเครดิตให้สาขาของคุณ</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อเติมให้สาขาของคุณ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5 px-8">
                        <div class="row justify-content-md-center">
                            <div class="col-lg-12 px-8">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <h3>เลือกสาขาของคุณ</h3>
                                            <v-select
                                                :options="listShop"
                                                class="custom-dropdown"
                                                label="labelText"
                                                placeholder="เลือกสาขาที่จะเติมเครดิตให้"
                                                :class="[ { 'is-invalid bd-danger': submitFormTopUp && $v.inputSelectShop.$error }, 'w-100' ]"
                                                v-model="inputSelectShop"
                                                :reduce="inputSelectShop => inputSelectShop.id"
                                                taggable
                                            >
                                                <template v-slot:option="option">
                                                    <span>{{ option.labelText }}</span>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <h3>ระบุจำนวนเครดิต ( 1 เครดิต = 1 บาท)</h3>
                                            <input
                                                v-model="fillAmount"
                                                type="number"
                                                class="form-control hide-arrow"
                                                placeholder="ขั้นต่ำ : 100 เครดิต สูงสุดไม่เกิน 50,000 เครดิต"
                                                :class="{ 'is-invalid': submitFormTopUp && $v.fillAmount.$error }" 
                                            />
                                            <div v-if="submitFormTopUp && !$v.fillAmount.required" 
                                                class="invalid-feedback" >
                                                กรุณากรอกจำนวนเงิน
                                            </div>
                                            <small v-if="submitFormTopUp && !$v.fillAmount.between" class="text-danger">กรุณากรอกจำนวนเงินขั้นต่ำ 100 บาทและสูงสุดไม่เกิน 50000 บาท</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <h3>หมายเหตุ</h3>
                                            <textarea
                                                v-model="remarkTopUp"
                                                rows="3"
                                                class="form-control"
                                                placeholder="กรุณาระบุ หมายเหตุ"
                                                :class="{ 'is-invalid': submitFormTopUp && $v.remarkTopUp.$error }"
                                            ></textarea>
                                            <label
                                                v-if="submitFormTopUp && !$v.remarkTopUp.required"
                                                class="invalid-feedback"
                                            >กรุณาระบุ หมายเหตุ</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row text-center">
                                    <div class="col-lg-12 py-5">
                                        <b-button class="px-5" variant="primary" @click="topUpCreditToShop()">
                                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadingTopUp"></i> เติมเครดิต
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getListShop } from "@/axios/shop.js";
import {
    required,
    between
} from "vuelidate/lib/validators";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    name: "topupcredittoshop",
    components:{
    },
    data() {
        return {
            inputSelectShop: null,
            listShop:[],
            fillAmount:'',
            remarkTopUp:"",
            submitFormTopUp: false,
            isLoadingTopUp: false
        }
    },
    validations:{
        inputSelectShop: { required },
        fillAmount: {
            required,
            between: between(100, 50000)
        },
        remarkTopUp: { required }
    },
    mounted() {
        getListShop().then( shop => {
            this.listShop = shop.map((s) => {
                s.labelText = s.shop_code + ' (' + s.name + ')';
                return s;
            });
        })
    },
    methods: {
        topUpCreditToShop(){
            this.isLoadingTopUp = true
            this.submitFormTopUp = true
            this.$v.$touch();
            if( this.$v.$invalid ){
                this.isLoadingTopUp = false
                return false
            }
            this.$http
                .post(
                this.$API_URL + "/wallet/agent/transaction/instant/deposit",
                {
                    credit: this.fillAmount,
                    remark: this.remarkTopUp,
                    shop_id: this.inputSelectShop
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    let resData = res.data; 
                    this.isLoadingTopUp = false
                    if(!resData.status){
                        showErrorModal('เติมเงินไม่สำเร็จ ' + resData.error.message)
                        return false;
                    }
                    showSuccessModal('เติมเงินสำเร็จ ยอดเครดิตคงเหลือของสาขา '+ this.$options.filters.numFormat(resData.data.balance,'0,0.00') + ' บาท')
                    this.fillAmount = ''
                    this.remarkTopUp = ''
                    this.submitFormTopUp = false
                })
                .catch(error => {
                });
        },
    },
    computed: {
    
    }
};
</script>